<template lang="pug">
#filtro-rastreabilidade.view-container
    .filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa.textoBusca',
                    type='text',
                    :placeholder='textoPlaceHolder',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                )
</template>

<script>

export default {
    name: 'FiltroRastreabilidade',
    props: {
        textoPlaceHolder: {
            type: String,
            default: () => ''
        }
    },

    data() {
        return {
            pesquisa: {
                textoBusca: '',
                dataInicioPesquisa: '',
                dataFimPesquisa: '',
                fazendasCertificadas: false
            }
        };
    },

    methods: {
        pesquisar() {
            this.$emit('atualizar-filtro', this.pesquisa);
        }
    }
};
</script>

<style lang="scss" scoped>
.filtros {
    display: flex;
    justify-content: space-between;
}

.pesquisa-inteligente__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}
</style>
